(() => {
  if (window.spNavigationV3Bound) return;
  window.spNavigationV3Bound = true;
  const timers = new WeakMap();
  const suppressed = new WeakSet();
  const media = window.matchMedia('(min-width:1100px) and (hover:hover) and (pointer:fine)');
  const expanded = () => document.querySelectorAll('.sp-nav__disclosure[open]');
  const cancel = item => { clearTimeout(timers.get(item)); timers.delete(item); };
  const close = (node, restoreFocus = false) => {
    cancel(node.closest('.sp-nav__item'));
    node.open = false;
    if (restoreFocus) node.querySelector('summary')?.focus();
  };
  const open = node => {
    expanded().forEach(other => { if (other !== node) close(other); });
    node.open = true;
  };
  document.addEventListener('toggle', event => {
    const node = event.target;
    if (!(node instanceof HTMLDetailsElement) || !node.matches('.sp-nav__disclosure') || !node.open) return;
    expanded().forEach(other => { if (other !== node) close(other); });
    const panel = node.querySelector('.sp-nav__panel');
    if (panel) {
      panel.classList.remove('sp-nav__panel--edge');
      const bounds = panel.getBoundingClientRect();
      if (bounds.right > window.innerWidth - 24) panel.classList.add('sp-nav__panel--edge');
    }
  }, true);
  document.addEventListener('pointerover', event => {
    if (!media.matches || event.pointerType !== 'mouse' || !(event.target instanceof Element)) return;
    const item = event.target.closest('.sp-nav__item');
    if (!item) return;
    if (event.relatedTarget instanceof Node && item.contains(event.relatedTarget)) return;
    cancel(item);
    const node = item.querySelector('.sp-nav__disclosure');
    if (!node || suppressed.has(item)) return;
    timers.set(item, setTimeout(() => open(node), 100));
  });
  document.addEventListener('pointerout', event => {
    if (!media.matches || event.pointerType !== 'mouse' || !(event.target instanceof Element)) return;
    const item = event.target.closest('.sp-nav__item');
    if (!item || (event.relatedTarget instanceof Node && item.contains(event.relatedTarget))) return;
    suppressed.delete(item);
    cancel(item);
    const node = item.querySelector('.sp-nav__disclosure');
    if (node) timers.set(item, setTimeout(() => {
      if (!item.matches(':hover') && !item.contains(document.activeElement)) close(node);
    }, 180));
  });
  document.addEventListener('click', event => {
    if (!(event.target instanceof Node)) return;
    expanded().forEach(node => {
      if (!node.closest('.sp-nav__item').contains(event.target)) close(node);
    });
    if (event.target instanceof Element) {
      const summary = event.target.closest('.sp-nav summary');
      if (summary) cancel(summary.closest('.sp-nav__item'));
    }
  });
  document.addEventListener('focusin', event => {
    if (!(event.target instanceof Node)) return;
    expanded().forEach(node => {
      if (!node.closest('.sp-nav__item').contains(event.target)) close(node);
    });
  });
  document.addEventListener('keydown', event => {
    if (!(event.target instanceof Element)) return;
    const item = event.target.closest('.sp-nav__item');
    const node = item?.querySelector('.sp-nav__disclosure');
    if (event.key === 'Escape') {
      if (node?.open) {
        if (item.matches(':hover')) suppressed.add(item);
        close(node, true);
        event.preventDefault();
      } else expanded().forEach(other => close(other));
    }
    if (event.key === 'ArrowDown' && node && !event.target.closest('.sp-nav__panel')) {
      cancel(item);
      open(node);
      node.querySelector('.sp-nav__panel a')?.focus();
      event.preventDefault();
    }
  });
  window.addEventListener('resize', () => expanded().forEach(node => close(node)), { passive:true });
})();
